import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats duration in seconds to a human-readable string
 * Examples: "30s", "5m", "1h 23m", "2h"
 * 
 * @param seconds - Duration in seconds (can be undefined/null)
 * @returns Formatted duration string
 */
export function formatDuration(seconds?: number): string {
  if (!seconds || seconds < 1) return '0s'
  
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60
  
  if (hours > 0) {
    if (minutes > 0) {
      return `${hours}h ${minutes}m`
    }
    return `${hours}h`
  }
  
  if (minutes > 0) {
    if (remainingSeconds > 0 && minutes < 5) {
      // Show seconds for short durations under 5 minutes for better precision
      return `${minutes}m ${remainingSeconds}s`
    }
    return `${minutes}m`
  }
  
  return `${remainingSeconds}s`
}
